import React, { useContext, useEffect, useRef } from 'react';
import { cn } from "@bem-react/classname";
import { inject, observer } from "mobx-react";
import { RegContext } from "../../templateElements/Registration/RegContext";
import './style.scss';

const Select = inject('appStore', 'kafkaStore')(observer((props) => {
  const {
    kafkaStore: {
      imprintHash
    },
    className,
    selectedOption,
    onSelect,
    options,
    label,
  } = props;

  const {
    isCountryListOpen,
    isCurrencyListOpen,
    setIsCurrencyListOpen
  } = useContext(RegContext);

  const wrapperRef = useRef(null)
  const selectCn = cn(className);

  const handleClick = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setIsCurrencyListOpen(false);
    }
    if (e.target.tagName === 'LI' && e.target.className === 'СurrencySelect-Item') {
      handleClickItem(e)
    }
  }

  const handleClickItem = (e) => {
    const clickedItem = options[e.target.getAttribute("data-index")];
    if (e.target.getAttribute("data-index") !== selectedOption) {
      onSelect(clickedItem)
    }
    setIsCurrencyListOpen(false);
  }

  const listItems = () => options.map((item, index) => (
    <li onClick={handleClick} className={selectCn('Item')} data-index={index} key={index}>
      {item.label}
    </li>
  ))

  useEffect(() => {
    isCountryListOpen && setIsCurrencyListOpen(false);
  }, [isCountryListOpen]);

  return (
    <div ref={wrapperRef} className={`${selectCn('Select')} Select ${isCurrencyListOpen ? 'Select_active' : ''}`}>
      <span className={`${selectCn('Select-Label')} Select-Label`}>{label}</span>
      <div className={`${selectCn('SelectWrapper')} Select-Wrapper`} onClick={() => setIsCurrencyListOpen(!isCurrencyListOpen)}>
        <span className={`${selectCn('SelectLabel')} Selected-Value`}>{selectedOption?.label}</span>
        <span className={`${selectCn('Arrow')} Select-Arrow`} />
      </div>
      <ul className={selectCn('List')}>
        {listItems()}
      </ul>
    </div>
  );
}))

export default Select;